import {Box, Button} from '@mui/material';
import { Tag as TagComponent } from "components/tag"
import { Text } from "components/text"
import { spacing } from "deprecated-theme"
import { Attachment, Tag } from "lib/types"
import React from "react"
import {isNilOrEmpty, pxToRem} from 'utils/helpers';

interface AttachmentsTagsProps {
  attachments?: Array<Attachment>
  tags?: Array<Tag>
  onViewPress: (atch: Attachment) => void
}
export const AttachmentsTagsMobile = (props: AttachmentsTagsProps) => {
  const { attachments, tags, onViewPress } = props

  return (
    <div className="show-mobile">
      <Box display="flex" flexDirection="column" marginTop={pxToRem(20)}>
        {!isNilOrEmpty(attachments) && (
          <>
            <Text preset="bodyLargePrimary" text="Additional Resources" />
            {/*// @ts-ignore*/}
            {attachments.map((atch: Attachment) => {
              const onAttachmentPress = () => {
                onViewPress(atch)
              }
              return (
                <Box
                  key={`mobile-attachment-${atch.id}`}
                  display="flex"
                  marginTop={pxToRem(16)}
                  justifyContent="space-between"
                  alignItems="center">
                  <Text preset="bodyMediumPrimary" text={atch.attributes.caption} />
                  <Button
                    variant="outlined"
                    onClick={onAttachmentPress}
                    style={{
                      width: 140,
                      marginLeft: spacing[2],
                    }}>
                    VIEW
                  </Button>
                </Box>
              )
            })}
          </>
        )}

        <Box display="flex" flexDirection="row" flexWrap="wrap" marginTop={pxToRem(16)}>
          {/*// @ts-ignore*/}
          {tags.map((tag: Tag) => {
            return <TagComponent key={tag.id} text={tag.attributes.name} />
          })}
        </Box>
      </Box>
      {/* @ts-ignore */}
      <style jsx>
        {`
          .show-mobile {
            display: block;
          }

          @media screen and (min-width: 1024px) {
            .show-mobile {
              display: none;
            }
          }
        `}
      </style>
    </div>
  )
}
